export enum DATA_MOCK {
    MATERIAL_VID = 'Training Video',
    MATERIAL_DOCS = 'Quick Start guide',
    SRC_DOCS = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf',
    SRC_VID_PLAY = 'https://vjs.zencdn.net/v/oceans.mp4',
    SRC_VID = 'https://www.youtube.com/embed/yv6r0aTfCy0?enablejsapi=1',
    NAME_EMAIL1 = 'psesourcps',
    EMAIL1 = 'psesourcps@ps.ge.com',
    NAME_EMAIL2 = 'lcoehelpdesk',
    EMAIL2 = 'lcoehelpdesk@ge.com',
    IMAGE1 = '../../../../../assets/images/Wind-Farms.PNG',
    IMAGE2 = '../../../../../assets/images/hydroelectric.PNG',
    TYPE_DOCS = 'Docs',
    TYPE_VID = 'Vid',
}
export enum APPLICATION_MOCK {
    CLEAR_ORBIT = 'Clear Orbit',
    OTM = 'OTM',
    MTA = 'MTA',
    SDX = 'SDX',
    ISUPPLIER = 'iSupplier',
    ARIBA = 'Ariba',
    SUPPLIER_CONNECT = 'Supplier Connect',
}
export enum TYPE_FILE {
    DOCUMENT = 'DOCUMENT',
    THUMBNAIL = 'THUMBNAIL',
    VIDEO = 'VIDEO',
    KEY_DOCUMENT = 'Document',
    KEY_VIDEO = 'Video'
}
export enum BOLD_ENUMS {
    COLOR_BLUE = 'bold360-blue',
    COLOR_GREEN = 'bold360-green',
    CLOSE = 'Close',
    OPEN = 'Open',
    ICON_DOWN = 'fa-angle-double-down',
    ICON_UP = 'fa-angle-double-up'
}

export enum GSL_INFO {
    GSL_NUMBER = 'gslNumber',
    SUPPLIER_NAME = 'supplierName',
    PARENT_CONPANY_NAME = 'parentCompanyName',
}

